import React from 'react';
import NavPills from 'components/NavPills/NavPills.js';
import d2rsIcon from '../../assets/img/d2rsiconblock.png';
import breakpointsImg from '../../assets/img/breakpoints.png';
import amaImg from '../../assets/img/ama.png';
import assaImg from '../../assets/img/assa.png';
import necImg from '../../assets/img/nec.png';
import barbImg from '../../assets/img/barb.png';
import palaImg from '../../assets/img/pala.png';
import sosoImg from '../../assets/img/soso.png';
import duduImg from '../../assets/img/dudu.png';
import Card from 'components/Card/Card.js';
import CardBody from 'components/Card/CardBody.js';

interface ClassContentProps {
  title: string;
  children: React.ReactNode;
}

const ClassContent: React.FC<ClassContentProps> = ({ children }) => (
  <Card>
    <CardBody>{children}</CardBody>
  </Card>
);

const bpClasses = [
  {
    name: 'Amazon',
    image: amaImg,
    content: (
      <ClassContent title="Amazon">
        <div>
          <h3>Amazon FHR</h3>
          <table style={{ borderCollapse: 'collapse', width: '100%' }}>
            <thead>
              <tr>
                <th style={{ border: '1px solid black', padding: '8px', textAlign: 'center' }}>
                  %
                </th>
                <th style={{ border: '1px solid black', padding: '8px', textAlign: 'center' }}>
                  Frames
                </th>
              </tr>
            </thead>
            <tbody>
              <tr>
                <td style={{ border: '1px solid black', padding: '8px', textAlign: 'center' }}>
                  0%
                </td>
                <td style={{ border: '1px solid black', padding: '8px', textAlign: 'center' }}>
                  11
                </td>
              </tr>
              <tr>
                <td style={{ border: '1px solid black', padding: '8px', textAlign: 'center' }}>
                  6%
                </td>
                <td style={{ border: '1px solid black', padding: '8px', textAlign: 'center' }}>
                  10
                </td>
              </tr>
              <tr>
                <td style={{ border: '1px solid black', padding: '8px', textAlign: 'center' }}>
                  13%
                </td>
                <td style={{ border: '1px solid black', padding: '8px', textAlign: 'center' }}>
                  9
                </td>
              </tr>
              <tr>
                <td style={{ border: '1px solid black', padding: '8px', textAlign: 'center' }}>
                  20%
                </td>
                <td style={{ border: '1px solid black', padding: '8px', textAlign: 'center' }}>
                  8
                </td>
              </tr>
              <tr>
                <td style={{ border: '1px solid black', padding: '8px', textAlign: 'center' }}>
                  32%
                </td>
                <td style={{ border: '1px solid black', padding: '8px', textAlign: 'center' }}>
                  7
                </td>
              </tr>
              <tr>
                <td style={{ border: '1px solid black', padding: '8px', textAlign: 'center' }}>
                  52%
                </td>
                <td style={{ border: '1px solid black', padding: '8px', textAlign: 'center' }}>
                  6
                </td>
              </tr>
              <tr>
                <td style={{ border: '1px solid black', padding: '8px', textAlign: 'center' }}>
                  86%
                </td>
                <td style={{ border: '1px solid black', padding: '8px', textAlign: 'center' }}>
                  5
                </td>
              </tr>
              <tr>
                <td style={{ border: '1px solid black', padding: '8px', textAlign: 'center' }}>
                  174%
                </td>
                <td style={{ border: '1px solid black', padding: '8px', textAlign: 'center' }}>
                  4
                </td>
              </tr>
              <tr>
                <td style={{ border: '1px solid black', padding: '8px', textAlign: 'center' }}>
                  600%
                </td>
                <td style={{ border: '1px solid black', padding: '8px', textAlign: 'center' }}>
                  3
                </td>
              </tr>
            </tbody>
          </table>

          <h3>Amazon FCR</h3>
          <table style={{ borderCollapse: 'collapse', width: '100%' }}>
            <thead>
              <tr>
                <th style={{ border: '1px solid black', padding: '8px', textAlign: 'center' }}>
                  %
                </th>
                <th style={{ border: '1px solid black', padding: '8px', textAlign: 'center' }}>
                  Frames
                </th>
              </tr>
            </thead>
            <tbody>
              <tr>
                <td style={{ border: '1px solid black', padding: '8px', textAlign: 'center' }}>
                  0%
                </td>
                <td style={{ border: '1px solid black', padding: '8px', textAlign: 'center' }}>
                  19
                </td>
              </tr>
              <tr>
                <td style={{ border: '1px solid black', padding: '8px', textAlign: 'center' }}>
                  7%
                </td>
                <td style={{ border: '1px solid black', padding: '8px', textAlign: 'center' }}>
                  18
                </td>
              </tr>
              <tr>
                <td style={{ border: '1px solid black', padding: '8px', textAlign: 'center' }}>
                  14%
                </td>
                <td style={{ border: '1px solid black', padding: '8px', textAlign: 'center' }}>
                  17
                </td>
              </tr>
              <tr>
                <td style={{ border: '1px solid black', padding: '8px', textAlign: 'center' }}>
                  22%
                </td>
                <td style={{ border: '1px solid black', padding: '8px', textAlign: 'center' }}>
                  16
                </td>
              </tr>
              <tr>
                <td style={{ border: '1px solid black', padding: '8px', textAlign: 'center' }}>
                  32%
                </td>
                <td style={{ border: '1px solid black', padding: '8px', textAlign: 'center' }}>
                  15
                </td>
              </tr>
              <tr>
                <td style={{ border: '1px solid black', padding: '8px', textAlign: 'center' }}>
                  48%
                </td>
                <td style={{ border: '1px solid black', padding: '8px', textAlign: 'center' }}>
                  14
                </td>
              </tr>
              <tr>
                <td style={{ border: '1px solid black', padding: '8px', textAlign: 'center' }}>
                  68%
                </td>
                <td style={{ border: '1px solid black', padding: '8px', textAlign: 'center' }}>
                  13
                </td>
              </tr>
              <tr>
                <td style={{ border: '1px solid black', padding: '8px', textAlign: 'center' }}>
                  99%
                </td>
                <td style={{ border: '1px solid black', padding: '8px', textAlign: 'center' }}>
                  12
                </td>
              </tr>
              <tr>
                <td style={{ border: '1px solid black', padding: '8px', textAlign: 'center' }}>
                  152%
                </td>
                <td style={{ border: '1px solid black', padding: '8px', textAlign: 'center' }}>
                  11
                </td>
              </tr>
            </tbody>
          </table>

          <h3>Amazon Faster Block Rate Frames (1-handed or 2-handed sword held in one hand)</h3>
          <table style={{ borderCollapse: 'collapse', width: '100%' }}>
            <thead>
              <tr>
                <th style={{ border: '1px solid black', padding: '8px', textAlign: 'center' }}>
                  %
                </th>
                <th style={{ border: '1px solid black', padding: '8px', textAlign: 'center' }}>
                  Frames
                </th>
              </tr>
            </thead>
            <tbody>
              <tr>
                <td style={{ border: '1px solid black', padding: '8px', textAlign: 'center' }}>
                  0%
                </td>
                <td style={{ border: '1px solid black', padding: '8px', textAlign: 'center' }}>
                  17
                </td>
              </tr>
              <tr>
                <td style={{ border: '1px solid black', padding: '8px', textAlign: 'center' }}>
                  4%
                </td>
                <td style={{ border: '1px solid black', padding: '8px', textAlign: 'center' }}>
                  16
                </td>
              </tr>
              <tr>
                <td style={{ border: '1px solid black', padding: '8px', textAlign: 'center' }}>
                  6%
                </td>
                <td style={{ border: '1px solid black', padding: '8px', textAlign: 'center' }}>
                  15
                </td>
              </tr>
              <tr>
                <td style={{ border: '1px solid black', padding: '8px', textAlign: 'center' }}>
                  11%
                </td>
                <td style={{ border: '1px solid black', padding: '8px', textAlign: 'center' }}>
                  14
                </td>
              </tr>
              <tr>
                <td style={{ border: '1px solid black', padding: '8px', textAlign: 'center' }}>
                  15%
                </td>
                <td style={{ border: '1px solid black', padding: '8px', textAlign: 'center' }}>
                  13
                </td>
              </tr>
              <tr>
                <td style={{ border: '1px solid black', padding: '8px', textAlign: 'center' }}>
                  23%
                </td>
                <td style={{ border: '1px solid black', padding: '8px', textAlign: 'center' }}>
                  12
                </td>
              </tr>
              <tr>
                <td style={{ border: '1px solid black', padding: '8px', textAlign: 'center' }}>
                  29%
                </td>
                <td style={{ border: '1px solid black', padding: '8px', textAlign: 'center' }}>
                  11
                </td>
              </tr>
              <tr>
                <td style={{ border: '1px solid black', padding: '8px', textAlign: 'center' }}>
                  40%
                </td>
                <td style={{ border: '1px solid black', padding: '8px', textAlign: 'center' }}>
                  10
                </td>
              </tr>
              <tr>
                <td style={{ border: '1px solid black', padding: '8px', textAlign: 'center' }}>
                  56%
                </td>
                <td style={{ border: '1px solid black', padding: '8px', textAlign: 'center' }}>
                  9
                </td>
              </tr>
              <tr>
                <td style={{ border: '1px solid black', padding: '8px', textAlign: 'center' }}>
                  80%
                </td>
                <td style={{ border: '1px solid black', padding: '8px', textAlign: 'center' }}>
                  8
                </td>
              </tr>
              <tr>
                <td style={{ border: '1px solid black', padding: '8px', textAlign: 'center' }}>
                  120%
                </td>
                <td style={{ border: '1px solid black', padding: '8px', textAlign: 'center' }}>
                  7
                </td>
              </tr>
              <tr>
                <td style={{ border: '1px solid black', padding: '8px', textAlign: 'center' }}>
                  200%
                </td>
                <td style={{ border: '1px solid black', padding: '8px', textAlign: 'center' }}>
                  6
                </td>
              </tr>
              <tr>
                <td style={{ border: '1px solid black', padding: '8px', textAlign: 'center' }}>
                  480%
                </td>
                <td style={{ border: '1px solid black', padding: '8px', textAlign: 'center' }}>
                  5
                </td>
              </tr>
            </tbody>
          </table>

          <h3>Amazon Faster Block Rate Frames (any other weapon)</h3>
          <table style={{ borderCollapse: 'collapse', width: '100%' }}>
            <thead>
              <tr>
                <th style={{ border: '1px solid black', padding: '8px', textAlign: 'center' }}>
                  %
                </th>
                <th style={{ border: '1px solid black', padding: '8px', textAlign: 'center' }}>
                  Frames
                </th>
              </tr>
            </thead>
            <tbody>
              <tr>
                <td style={{ border: '1px solid black', padding: '8px', textAlign: 'center' }}>
                  0%
                </td>
                <td style={{ border: '1px solid black', padding: '8px', textAlign: 'center' }}>
                  5
                </td>
              </tr>
              <tr>
                <td style={{ border: '1px solid black', padding: '8px', textAlign: 'center' }}>
                  13%
                </td>
                <td style={{ border: '1px solid black', padding: '8px', textAlign: 'center' }}>
                  4
                </td>
              </tr>
              <tr>
                <td style={{ border: '1px solid black', padding: '8px', textAlign: 'center' }}>
                  32%
                </td>
                <td style={{ border: '1px solid black', padding: '8px', textAlign: 'center' }}>
                  3
                </td>
              </tr>
              <tr>
                <td style={{ border: '1px solid black', padding: '8px', textAlign: 'center' }}>
                  86%
                </td>
                <td style={{ border: '1px solid black', padding: '8px', textAlign: 'center' }}>
                  2
                </td>
              </tr>
              <tr>
                <td style={{ border: '1px solid black', padding: '8px', textAlign: 'center' }}>
                  600%
                </td>
                <td style={{ border: '1px solid black', padding: '8px', textAlign: 'center' }}>
                  1
                </td>
              </tr>
            </tbody>
          </table>
        </div>
      </ClassContent>
    ),
  },
  {
    name: 'Assassin',
    image: assaImg,
    content: (
      <ClassContent title="Assassin">
        <div>
          <h3>Assassin FHR</h3>
          <table style={{ borderCollapse: 'collapse', width: '100%' }}>
            <thead>
              <tr>
                <th style={{ border: '1px solid black', padding: '8px', textAlign: 'center' }}>
                  %
                </th>
                <th style={{ border: '1px solid black', padding: '8px', textAlign: 'center' }}>
                  Frames
                </th>
              </tr>
            </thead>
            <tbody>
              <tr>
                <td style={{ border: '1px solid black', padding: '8px', textAlign: 'center' }}>
                  0%
                </td>
                <td style={{ border: '1px solid black', padding: '8px', textAlign: 'center' }}>
                  9
                </td>
              </tr>
              <tr>
                <td style={{ border: '1px solid black', padding: '8px', textAlign: 'center' }}>
                  7%
                </td>
                <td style={{ border: '1px solid black', padding: '8px', textAlign: 'center' }}>
                  8
                </td>
              </tr>
              <tr>
                <td style={{ border: '1px solid black', padding: '8px', textAlign: 'center' }}>
                  15%
                </td>
                <td style={{ border: '1px solid black', padding: '8px', textAlign: 'center' }}>
                  7
                </td>
              </tr>
              <tr>
                <td style={{ border: '1px solid black', padding: '8px', textAlign: 'center' }}>
                  27%
                </td>
                <td style={{ border: '1px solid black', padding: '8px', textAlign: 'center' }}>
                  6
                </td>
              </tr>
              <tr>
                <td style={{ border: '1px solid black', padding: '8px', textAlign: 'center' }}>
                  48%
                </td>
                <td style={{ border: '1px solid black', padding: '8px', textAlign: 'center' }}>
                  5
                </td>
              </tr>
              <tr>
                <td style={{ border: '1px solid black', padding: '8px', textAlign: 'center' }}>
                  86%
                </td>
                <td style={{ border: '1px solid black', padding: '8px', textAlign: 'center' }}>
                  4
                </td>
              </tr>
              <tr>
                <td style={{ border: '1px solid black', padding: '8px', textAlign: 'center' }}>
                  200%
                </td>
                <td style={{ border: '1px solid black', padding: '8px', textAlign: 'center' }}>
                  3
                </td>
              </tr>
              <tr>
                <td style={{ border: '1px solid black', padding: '8px', textAlign: 'center' }}>
                  4680%
                </td>
                <td style={{ border: '1px solid black', padding: '8px', textAlign: 'center' }}>
                  2
                </td>
              </tr>
            </tbody>
          </table>

          <h3>Assassin FCR</h3>
          <table style={{ borderCollapse: 'collapse', width: '100%' }}>
            <thead>
              <tr>
                <th style={{ border: '1px solid black', padding: '8px', textAlign: 'center' }}>
                  %
                </th>
                <th style={{ border: '1px solid black', padding: '8px', textAlign: 'center' }}>
                  Frames
                </th>
              </tr>
            </thead>
            <tbody>
              <tr>
                <td style={{ border: '1px solid black', padding: '8px', textAlign: 'center' }}>
                  0%
                </td>
                <td style={{ border: '1px solid black', padding: '8px', textAlign: 'center' }}>
                  16
                </td>
              </tr>
              <tr>
                <td style={{ border: '1px solid black', padding: '8px', textAlign: 'center' }}>
                  8%
                </td>
                <td style={{ border: '1px solid black', padding: '8px', textAlign: 'center' }}>
                  15
                </td>
              </tr>
              <tr>
                <td style={{ border: '1px solid black', padding: '8px', textAlign: 'center' }}>
                  16%
                </td>
                <td style={{ border: '1px solid black', padding: '8px', textAlign: 'center' }}>
                  14
                </td>
              </tr>
              <tr>
                <td style={{ border: '1px solid black', padding: '8px', textAlign: 'center' }}>
                  27%
                </td>
                <td style={{ border: '1px solid black', padding: '8px', textAlign: 'center' }}>
                  13
                </td>
              </tr>
              <tr>
                <td style={{ border: '1px solid black', padding: '8px', textAlign: 'center' }}>
                  42%
                </td>
                <td style={{ border: '1px solid black', padding: '8px', textAlign: 'center' }}>
                  12
                </td>
              </tr>
              <tr>
                <td style={{ border: '1px solid black', padding: '8px', textAlign: 'center' }}>
                  65%
                </td>
                <td style={{ border: '1px solid black', padding: '8px', textAlign: 'center' }}>
                  11
                </td>
              </tr>
              <tr>
                <td style={{ border: '1px solid black', padding: '8px', textAlign: 'center' }}>
                  102%
                </td>
                <td style={{ border: '1px solid black', padding: '8px', textAlign: 'center' }}>
                  10
                </td>
              </tr>
              <tr>
                <td style={{ border: '1px solid black', padding: '8px', textAlign: 'center' }}>
                  174%
                </td>
                <td style={{ border: '1px solid black', padding: '8px', textAlign: 'center' }}>
                  9
                </td>
              </tr>
            </tbody>
          </table>

          <h3>Assassin FBR</h3>
          <table style={{ borderCollapse: 'collapse', width: '100%' }}>
            <thead>
              <tr>
                <th style={{ border: '1px solid black', padding: '8px', textAlign: 'center' }}>
                  %
                </th>
                <th style={{ border: '1px solid black', padding: '8px', textAlign: 'center' }}>
                  Frames
                </th>
              </tr>
            </thead>
            <tbody>
              <tr>
                <td style={{ border: '1px solid black', padding: '8px', textAlign: 'center' }}>
                  0%
                </td>
                <td style={{ border: '1px solid black', padding: '8px', textAlign: 'center' }}>
                  5
                </td>
              </tr>
              <tr>
                <td style={{ border: '1px solid black', padding: '8px', textAlign: 'center' }}>
                  13%
                </td>
                <td style={{ border: '1px solid black', padding: '8px', textAlign: 'center' }}>
                  4
                </td>
              </tr>
              <tr>
                <td style={{ border: '1px solid black', padding: '8px', textAlign: 'center' }}>
                  32%
                </td>
                <td style={{ border: '1px solid black', padding: '8px', textAlign: 'center' }}>
                  3
                </td>
              </tr>
              <tr>
                <td style={{ border: '1px solid black', padding: '8px', textAlign: 'center' }}>
                  86%
                </td>
                <td style={{ border: '1px solid black', padding: '8px', textAlign: 'center' }}>
                  2
                </td>
              </tr>
              <tr>
                <td style={{ border: '1px solid black', padding: '8px', textAlign: 'center' }}>
                  600%
                </td>
                <td style={{ border: '1px solid black', padding: '8px', textAlign: 'center' }}>
                  1
                </td>
              </tr>
            </tbody>
          </table>
        </div>
      </ClassContent>
    ),
  },
  {
    name: 'Necromancer',
    image: necImg,
    content: (
      <ClassContent title="Necromancer">
        <div>
          <h3>Necromancer FHR</h3>
          <table style={{ borderCollapse: 'collapse', width: '100%' }}>
            <thead>
              <tr>
                <th style={{ border: '1px solid black', padding: '8px', textAlign: 'center' }}>
                  %
                </th>
                <th style={{ border: '1px solid black', padding: '8px', textAlign: 'center' }}>
                  Frames
                </th>
              </tr>
            </thead>
            <tbody>
              <tr>
                <td style={{ border: '1px solid black', padding: '8px', textAlign: 'center' }}>
                  0%
                </td>
                <td style={{ border: '1px solid black', padding: '8px', textAlign: 'center' }}>
                  13
                </td>
              </tr>
              <tr>
                <td style={{ border: '1px solid black', padding: '8px', textAlign: 'center' }}>
                  5%
                </td>
                <td style={{ border: '1px solid black', padding: '8px', textAlign: 'center' }}>
                  12
                </td>
              </tr>
              <tr>
                <td style={{ border: '1px solid black', padding: '8px', textAlign: 'center' }}>
                  10%
                </td>
                <td style={{ border: '1px solid black', padding: '8px', textAlign: 'center' }}>
                  11
                </td>
              </tr>
              <tr>
                <td style={{ border: '1px solid black', padding: '8px', textAlign: 'center' }}>
                  16%
                </td>
                <td style={{ border: '1px solid black', padding: '8px', textAlign: 'center' }}>
                  10
                </td>
              </tr>
              <tr>
                <td style={{ border: '1px solid black', padding: '8px', textAlign: 'center' }}>
                  26%
                </td>
                <td style={{ border: '1px solid black', padding: '8px', textAlign: 'center' }}>
                  9
                </td>
              </tr>
              <tr>
                <td style={{ border: '1px solid black', padding: '8px', textAlign: 'center' }}>
                  39%
                </td>
                <td style={{ border: '1px solid black', padding: '8px', textAlign: 'center' }}>
                  8
                </td>
              </tr>
              <tr>
                <td style={{ border: '1px solid black', padding: '8px', textAlign: 'center' }}>
                  56%
                </td>
                <td style={{ border: '1px solid black', padding: '8px', textAlign: 'center' }}>
                  7
                </td>
              </tr>
              <tr>
                <td style={{ border: '1px solid black', padding: '8px', textAlign: 'center' }}>
                  86%
                </td>
                <td style={{ border: '1px solid black', padding: '8px', textAlign: 'center' }}>
                  6
                </td>
              </tr>
              <tr>
                <td style={{ border: '1px solid black', padding: '8px', textAlign: 'center' }}>
                  152%
                </td>
                <td style={{ border: '1px solid black', padding: '8px', textAlign: 'center' }}>
                  5
                </td>
              </tr>
              <tr>
                <td style={{ border: '1px solid black', padding: '8px', textAlign: 'center' }}>
                  377%
                </td>
                <td style={{ border: '1px solid black', padding: '8px', textAlign: 'center' }}>
                  4
                </td>
              </tr>
            </tbody>
          </table>

          <h3>Necromancer FCR (Necromancer)</h3>
          <table style={{ borderCollapse: 'collapse', width: '100%' }}>
            <thead>
              <tr>
                <th style={{ border: '1px solid black', padding: '8px', textAlign: 'center' }}>
                  %
                </th>
                <th style={{ border: '1px solid black', padding: '8px', textAlign: 'center' }}>
                  Frames
                </th>
              </tr>
            </thead>
            <tbody>
              <tr>
                <td style={{ border: '1px solid black', padding: '8px', textAlign: 'center' }}>
                  0%
                </td>
                <td style={{ border: '1px solid black', padding: '8px', textAlign: 'center' }}>
                  15
                </td>
              </tr>
              <tr>
                <td style={{ border: '1px solid black', padding: '8px', textAlign: 'center' }}>
                  9%
                </td>
                <td style={{ border: '1px solid black', padding: '8px', textAlign: 'center' }}>
                  14
                </td>
              </tr>
              <tr>
                <td style={{ border: '1px solid black', padding: '8px', textAlign: 'center' }}>
                  18%
                </td>
                <td style={{ border: '1px solid black', padding: '8px', textAlign: 'center' }}>
                  13
                </td>
              </tr>
              <tr>
                <td style={{ border: '1px solid black', padding: '8px', textAlign: 'center' }}>
                  30%
                </td>
                <td style={{ border: '1px solid black', padding: '8px', textAlign: 'center' }}>
                  12
                </td>
              </tr>
              <tr>
                <td style={{ border: '1px solid black', padding: '8px', textAlign: 'center' }}>
                  48%
                </td>
                <td style={{ border: '1px solid black', padding: '8px', textAlign: 'center' }}>
                  11
                </td>
              </tr>
              <tr>
                <td style={{ border: '1px solid black', padding: '8px', textAlign: 'center' }}>
                  75%
                </td>
                <td style={{ border: '1px solid black', padding: '8px', textAlign: 'center' }}>
                  10
                </td>
              </tr>
              <tr>
                <td style={{ border: '1px solid black', padding: '8px', textAlign: 'center' }}>
                  125%
                </td>
                <td style={{ border: '1px solid black', padding: '8px', textAlign: 'center' }}>
                  9
                </td>
              </tr>
            </tbody>
          </table>

          <h3>Necromancer FCR (Necromancer - Vampire)</h3>
          <table style={{ borderCollapse: 'collapse', width: '100%' }}>
            <thead>
              <tr>
                <th style={{ border: '1px solid black', padding: '8px', textAlign: 'center' }}>
                  %
                </th>
                <th style={{ border: '1px solid black', padding: '8px', textAlign: 'center' }}>
                  Frames
                </th>
              </tr>
            </thead>
            <tbody>
              <tr>
                <td style={{ border: '1px solid black', padding: '8px', textAlign: 'center' }}>
                  0%
                </td>
                <td style={{ border: '1px solid black', padding: '8px', textAlign: 'center' }}>
                  23
                </td>
              </tr>
              <tr>
                <td style={{ border: '1px solid black', padding: '8px', textAlign: 'center' }}>
                  6%
                </td>
                <td style={{ border: '1px solid black', padding: '8px', textAlign: 'center' }}>
                  22
                </td>
              </tr>
              <tr>
                <td style={{ border: '1px solid black', padding: '8px', textAlign: 'center' }}>
                  11%
                </td>
                <td style={{ border: '1px solid black', padding: '8px', textAlign: 'center' }}>
                  21
                </td>
              </tr>
              <tr>
                <td style={{ border: '1px solid black', padding: '8px', textAlign: 'center' }}>
                  18%
                </td>
                <td style={{ border: '1px solid black', padding: '8px', textAlign: 'center' }}>
                  20
                </td>
              </tr>
              <tr>
                <td style={{ border: '1px solid black', padding: '8px', textAlign: 'center' }}>
                  24%
                </td>
                <td style={{ border: '1px solid black', padding: '8px', textAlign: 'center' }}>
                  19
                </td>
              </tr>
              <tr>
                <td style={{ border: '1px solid black', padding: '8px', textAlign: 'center' }}>
                  35%
                </td>
                <td style={{ border: '1px solid black', padding: '8px', textAlign: 'center' }}>
                  18
                </td>
              </tr>
              <tr>
                <td style={{ border: '1px solid black', padding: '8px', textAlign: 'center' }}>
                  48%
                </td>
                <td style={{ border: '1px solid black', padding: '8px', textAlign: 'center' }}>
                  17
                </td>
              </tr>
              <tr>
                <td style={{ border: '1px solid black', padding: '8px', textAlign: 'center' }}>
                  65%
                </td>
                <td style={{ border: '1px solid black', padding: '8px', textAlign: 'center' }}>
                  16
                </td>
              </tr>
              <tr>
                <td style={{ border: '1px solid black', padding: '8px', textAlign: 'center' }}>
                  86%
                </td>
                <td style={{ border: '1px solid black', padding: '8px', textAlign: 'center' }}>
                  15
                </td>
              </tr>
              <tr>
                <td style={{ border: '1px solid black', padding: '8px', textAlign: 'center' }}>
                  120%
                </td>
                <td style={{ border: '1px solid black', padding: '8px', textAlign: 'center' }}>
                  14
                </td>
              </tr>
              <tr>
                <td style={{ border: '1px solid black', padding: '8px', textAlign: 'center' }}>
                  180%
                </td>
                <td style={{ border: '1px solid black', padding: '8px', textAlign: 'center' }}>
                  13
                </td>
              </tr>
            </tbody>
          </table>

          <h3>Necromancer FBR</h3>
          <table style={{ borderCollapse: 'collapse', width: '100%' }}>
            <thead>
              <tr>
                <th style={{ border: '1px solid black', padding: '8px', textAlign: 'center' }}>
                  %
                </th>
                <th style={{ border: '1px solid black', padding: '8px', textAlign: 'center' }}>
                  Frames
                </th>
              </tr>
            </thead>
            <tbody>
              <tr>
                <td style={{ border: '1px solid black', padding: '8px', textAlign: 'center' }}>
                  0%
                </td>
                <td style={{ border: '1px solid black', padding: '8px', textAlign: 'center' }}>
                  11
                </td>
              </tr>
              <tr>
                <td style={{ border: '1px solid black', padding: '8px', textAlign: 'center' }}>
                  6%
                </td>
                <td style={{ border: '1px solid black', padding: '8px', textAlign: 'center' }}>
                  10
                </td>
              </tr>
              <tr>
                <td style={{ border: '1px solid black', padding: '8px', textAlign: 'center' }}>
                  13%
                </td>
                <td style={{ border: '1px solid black', padding: '8px', textAlign: 'center' }}>
                  9
                </td>
              </tr>
              <tr>
                <td style={{ border: '1px solid black', padding: '8px', textAlign: 'center' }}>
                  20%
                </td>
                <td style={{ border: '1px solid black', padding: '8px', textAlign: 'center' }}>
                  8
                </td>
              </tr>
              <tr>
                <td style={{ border: '1px solid black', padding: '8px', textAlign: 'center' }}>
                  32%
                </td>
                <td style={{ border: '1px solid black', padding: '8px', textAlign: 'center' }}>
                  7
                </td>
              </tr>
              <tr>
                <td style={{ border: '1px solid black', padding: '8px', textAlign: 'center' }}>
                  52%
                </td>
                <td style={{ border: '1px solid black', padding: '8px', textAlign: 'center' }}>
                  6
                </td>
              </tr>
              <tr>
                <td style={{ border: '1px solid black', padding: '8px', textAlign: 'center' }}>
                  86%
                </td>
                <td style={{ border: '1px solid black', padding: '8px', textAlign: 'center' }}>
                  5
                </td>
              </tr>
              <tr>
                <td style={{ border: '1px solid black', padding: '8px', textAlign: 'center' }}>
                  174%
                </td>
                <td style={{ border: '1px solid black', padding: '8px', textAlign: 'center' }}>
                  4
                </td>
              </tr>
              <tr>
                <td style={{ border: '1px solid black', padding: '8px', textAlign: 'center' }}>
                  600%
                </td>
                <td style={{ border: '1px solid black', padding: '8px', textAlign: 'center' }}>
                  3
                </td>
              </tr>
            </tbody>
          </table>
        </div>
      </ClassContent>
    ),
  },
  {
    name: 'Barbarian',
    image: barbImg,
    content: (
      <ClassContent title="Barbarian">
        <div>
          <h3>Barbarian FHR</h3>
          <table style={{ borderCollapse: 'collapse', width: '100%' }}>
            <thead>
              <tr>
                <th style={{ border: '1px solid black', padding: '8px', textAlign: 'center' }}>
                  %
                </th>
                <th style={{ border: '1px solid black', padding: '8px', textAlign: 'center' }}>
                  Frames
                </th>
              </tr>
            </thead>
            <tbody>
              <tr>
                <td style={{ border: '1px solid black', padding: '8px', textAlign: 'center' }}>
                  0%
                </td>
                <td style={{ border: '1px solid black', padding: '8px', textAlign: 'center' }}>
                  9
                </td>
              </tr>
              <tr>
                <td style={{ border: '1px solid black', padding: '8px', textAlign: 'center' }}>
                  7%
                </td>
                <td style={{ border: '1px solid black', padding: '8px', textAlign: 'center' }}>
                  8
                </td>
              </tr>
              <tr>
                <td style={{ border: '1px solid black', padding: '8px', textAlign: 'center' }}>
                  15%
                </td>
                <td style={{ border: '1px solid black', padding: '8px', textAlign: 'center' }}>
                  7
                </td>
              </tr>
              <tr>
                <td style={{ border: '1px solid black', padding: '8px', textAlign: 'center' }}>
                  27%
                </td>
                <td style={{ border: '1px solid black', padding: '8px', textAlign: 'center' }}>
                  6
                </td>
              </tr>
              <tr>
                <td style={{ border: '1px solid black', padding: '8px', textAlign: 'center' }}>
                  48%
                </td>
                <td style={{ border: '1px solid black', padding: '8px', textAlign: 'center' }}>
                  5
                </td>
              </tr>
              <tr>
                <td style={{ border: '1px solid black', padding: '8px', textAlign: 'center' }}>
                  86%
                </td>
                <td style={{ border: '1px solid black', padding: '8px', textAlign: 'center' }}>
                  4
                </td>
              </tr>
              <tr>
                <td style={{ border: '1px solid black', padding: '8px', textAlign: 'center' }}>
                  200%
                </td>
                <td style={{ border: '1px solid black', padding: '8px', textAlign: 'center' }}>
                  3
                </td>
              </tr>
              <tr>
                <td style={{ border: '1px solid black', padding: '8px', textAlign: 'center' }}>
                  4680%
                </td>
                <td style={{ border: '1px solid black', padding: '8px', textAlign: 'center' }}>
                  2
                </td>
              </tr>
            </tbody>
          </table>

          <h3>Barbarian FCR</h3>
          <table style={{ borderCollapse: 'collapse', width: '100%' }}>
            <thead>
              <tr>
                <th style={{ border: '1px solid black', padding: '8px', textAlign: 'center' }}>
                  %
                </th>
                <th style={{ border: '1px solid black', padding: '8px', textAlign: 'center' }}>
                  Frames
                </th>
              </tr>
            </thead>
            <tbody>
              <tr>
                <td style={{ border: '1px solid black', padding: '8px', textAlign: 'center' }}>
                  0%
                </td>
                <td style={{ border: '1px solid black', padding: '8px', textAlign: 'center' }}>
                  13
                </td>
              </tr>
              <tr>
                <td style={{ border: '1px solid black', padding: '8px', textAlign: 'center' }}>
                  9%
                </td>
                <td style={{ border: '1px solid black', padding: '8px', textAlign: 'center' }}>
                  12
                </td>
              </tr>
              <tr>
                <td style={{ border: '1px solid black', padding: '8px', textAlign: 'center' }}>
                  20%
                </td>
                <td style={{ border: '1px solid black', padding: '8px', textAlign: 'center' }}>
                  11
                </td>
              </tr>
              <tr>
                <td style={{ border: '1px solid black', padding: '8px', textAlign: 'center' }}>
                  37%
                </td>
                <td style={{ border: '1px solid black', padding: '8px', textAlign: 'center' }}>
                  10
                </td>
              </tr>
              <tr>
                <td style={{ border: '1px solid black', padding: '8px', textAlign: 'center' }}>
                  63%
                </td>
                <td style={{ border: '1px solid black', padding: '8px', textAlign: 'center' }}>
                  9
                </td>
              </tr>
              <tr>
                <td style={{ border: '1px solid black', padding: '8px', textAlign: 'center' }}>
                  105%
                </td>
                <td style={{ border: '1px solid black', padding: '8px', textAlign: 'center' }}>
                  8
                </td>
              </tr>
              <tr>
                <td style={{ border: '1px solid black', padding: '8px', textAlign: 'center' }}>
                  200%
                </td>
                <td style={{ border: '1px solid black', padding: '8px', textAlign: 'center' }}>
                  7
                </td>
              </tr>
            </tbody>
          </table>

          <h3>Barbarian FBR</h3>
          <table style={{ borderCollapse: 'collapse', width: '100%' }}>
            <thead>
              <tr>
                <th style={{ border: '1px solid black', padding: '8px', textAlign: 'center' }}>
                  %
                </th>
                <th style={{ border: '1px solid black', padding: '8px', textAlign: 'center' }}>
                  Frames
                </th>
              </tr>
            </thead>
            <tbody>
              <tr>
                <td style={{ border: '1px solid black', padding: '8px', textAlign: 'center' }}>
                  0%
                </td>
                <td style={{ border: '1px solid black', padding: '8px', textAlign: 'center' }}>
                  7
                </td>
              </tr>
              <tr>
                <td style={{ border: '1px solid black', padding: '8px', textAlign: 'center' }}>
                  9%
                </td>
                <td style={{ border: '1px solid black', padding: '8px', textAlign: 'center' }}>
                  6
                </td>
              </tr>
              <tr>
                <td style={{ border: '1px solid black', padding: '8px', textAlign: 'center' }}>
                  20%
                </td>
                <td style={{ border: '1px solid black', padding: '8px', textAlign: 'center' }}>
                  5
                </td>
              </tr>
              <tr>
                <td style={{ border: '1px solid black', padding: '8px', textAlign: 'center' }}>
                  42%
                </td>
                <td style={{ border: '1px solid black', padding: '8px', textAlign: 'center' }}>
                  4
                </td>
              </tr>
              <tr>
                <td style={{ border: '1px solid black', padding: '8px', textAlign: 'center' }}>
                  86%
                </td>
                <td style={{ border: '1px solid black', padding: '8px', textAlign: 'center' }}>
                  3
                </td>
              </tr>
              <tr>
                <td style={{ border: '1px solid black', padding: '8px', textAlign: 'center' }}>
                  280%
                </td>
                <td style={{ border: '1px solid black', padding: '8px', textAlign: 'center' }}>
                  2
                </td>
              </tr>
            </tbody>
          </table>
        </div>
      </ClassContent>
    ),
  },
  {
    name: 'Paladin',
    image: palaImg,
    content: (
      <ClassContent title="Paladin">
        <div>
          <h3>Paladin FHR</h3>
          <table style={{ borderCollapse: 'collapse', width: '100%' }}>
            <thead>
              <tr>
                <th style={{ border: '1px solid black', padding: '8px', textAlign: 'center' }}>
                  %
                </th>
                <th style={{ border: '1px solid black', padding: '8px', textAlign: 'center' }}>
                  Frames
                </th>
              </tr>
            </thead>
            <tbody>
              <tr>
                <td style={{ border: '1px solid black', padding: '8px', textAlign: 'center' }}>
                  0%
                </td>
                <td style={{ border: '1px solid black', padding: '8px', textAlign: 'center' }}>
                  9
                </td>
              </tr>
              <tr>
                <td style={{ border: '1px solid black', padding: '8px', textAlign: 'center' }}>
                  7%
                </td>
                <td style={{ border: '1px solid black', padding: '8px', textAlign: 'center' }}>
                  8
                </td>
              </tr>
              <tr>
                <td style={{ border: '1px solid black', padding: '8px', textAlign: 'center' }}>
                  15%
                </td>
                <td style={{ border: '1px solid black', padding: '8px', textAlign: 'center' }}>
                  7
                </td>
              </tr>
              <tr>
                <td style={{ border: '1px solid black', padding: '8px', textAlign: 'center' }}>
                  27%
                </td>
                <td style={{ border: '1px solid black', padding: '8px', textAlign: 'center' }}>
                  6
                </td>
              </tr>
              <tr>
                <td style={{ border: '1px solid black', padding: '8px', textAlign: 'center' }}>
                  48%
                </td>
                <td style={{ border: '1px solid black', padding: '8px', textAlign: 'center' }}>
                  5
                </td>
              </tr>
              <tr>
                <td style={{ border: '1px solid black', padding: '8px', textAlign: 'center' }}>
                  86%
                </td>
                <td style={{ border: '1px solid black', padding: '8px', textAlign: 'center' }}>
                  4
                </td>
              </tr>
              <tr>
                <td style={{ border: '1px solid black', padding: '8px', textAlign: 'center' }}>
                  200%
                </td>
                <td style={{ border: '1px solid black', padding: '8px', textAlign: 'center' }}>
                  3
                </td>
              </tr>
              <tr>
                <td style={{ border: '1px solid black', padding: '8px', textAlign: 'center' }}>
                  4680%
                </td>
                <td style={{ border: '1px solid black', padding: '8px', textAlign: 'center' }}>
                  2
                </td>
              </tr>
            </tbody>
          </table>

          <h3>Paladin FCR</h3>
          <table style={{ borderCollapse: 'collapse', width: '100%' }}>
            <thead>
              <tr>
                <th style={{ border: '1px solid black', padding: '8px', textAlign: 'center' }}>
                  %
                </th>
                <th style={{ border: '1px solid black', padding: '8px', textAlign: 'center' }}>
                  Frames
                </th>
              </tr>
            </thead>
            <tbody>
              <tr>
                <td style={{ border: '1px solid black', padding: '8px', textAlign: 'center' }}>
                  0%
                </td>
                <td style={{ border: '1px solid black', padding: '8px', textAlign: 'center' }}>
                  15
                </td>
              </tr>
              <tr>
                <td style={{ border: '1px solid black', padding: '8px', textAlign: 'center' }}>
                  9%
                </td>
                <td style={{ border: '1px solid black', padding: '8px', textAlign: 'center' }}>
                  14
                </td>
              </tr>
              <tr>
                <td style={{ border: '1px solid black', padding: '8px', textAlign: 'center' }}>
                  18%
                </td>
                <td style={{ border: '1px solid black', padding: '8px', textAlign: 'center' }}>
                  13
                </td>
              </tr>
              <tr>
                <td style={{ border: '1px solid black', padding: '8px', textAlign: 'center' }}>
                  30%
                </td>
                <td style={{ border: '1px solid black', padding: '8px', textAlign: 'center' }}>
                  12
                </td>
              </tr>
              <tr>
                <td style={{ border: '1px solid black', padding: '8px', textAlign: 'center' }}>
                  48%
                </td>
                <td style={{ border: '1px solid black', padding: '8px', textAlign: 'center' }}>
                  11
                </td>
              </tr>
              <tr>
                <td style={{ border: '1px solid black', padding: '8px', textAlign: 'center' }}>
                  75%
                </td>
                <td style={{ border: '1px solid black', padding: '8px', textAlign: 'center' }}>
                  10
                </td>
              </tr>
              <tr>
                <td style={{ border: '1px solid black', padding: '8px', textAlign: 'center' }}>
                  125%
                </td>
                <td style={{ border: '1px solid black', padding: '8px', textAlign: 'center' }}>
                  9
                </td>
              </tr>
            </tbody>
          </table>

          <h3>Paladin FBR</h3>
          <table style={{ borderCollapse: 'collapse', width: '100%' }}>
            <thead>
              <tr>
                <th style={{ border: '1px solid black', padding: '8px', textAlign: 'center' }}>
                  Condition
                </th>
                <th style={{ border: '1px solid black', padding: '8px', textAlign: 'center' }}>
                  %
                </th>
                <th style={{ border: '1px solid black', padding: '8px', textAlign: 'center' }}>
                  Frames
                </th>
              </tr>
            </thead>
            <tbody>
              <tr>
                <td
                  rowSpan={2}
                  style={{ border: '1px solid black', padding: '8px', textAlign: 'center' }}
                >
                  Paladin (With Holy shield)
                </td>
                <td style={{ border: '1px solid black', padding: '8px', textAlign: 'center' }}>
                  0%
                </td>
                <td style={{ border: '1px solid black', padding: '8px', textAlign: 'center' }}>
                  2
                </td>
              </tr>
              <tr>
                <td style={{ border: '1px solid black', padding: '8px', textAlign: 'center' }}>
                  86%
                </td>
                <td style={{ border: '1px solid black', padding: '8px', textAlign: 'center' }}>
                  1
                </td>
              </tr>
              <tr>
                <td
                  rowSpan={5}
                  style={{ border: '1px solid black', padding: '8px', textAlign: 'center' }}
                >
                  Paladin (Without Holy shield)
                </td>
                <td style={{ border: '1px solid black', padding: '8px', textAlign: 'center' }}>
                  0%
                </td>
                <td style={{ border: '1px solid black', padding: '8px', textAlign: 'center' }}>
                  5
                </td>
              </tr>
              <tr>
                <td style={{ border: '1px solid black', padding: '8px', textAlign: 'center' }}>
                  13%
                </td>
                <td style={{ border: '1px solid black', padding: '8px', textAlign: 'center' }}>
                  4
                </td>
              </tr>
              <tr>
                <td style={{ border: '1px solid black', padding: '8px', textAlign: 'center' }}>
                  32%
                </td>
                <td style={{ border: '1px solid black', padding: '8px', textAlign: 'center' }}>
                  3
                </td>
              </tr>
              <tr>
                <td style={{ border: '1px solid black', padding: '8px', textAlign: 'center' }}>
                  86%
                </td>
                <td style={{ border: '1px solid black', padding: '8px', textAlign: 'center' }}>
                  2
                </td>
              </tr>
              <tr>
                <td style={{ border: '1px solid black', padding: '8px', textAlign: 'center' }}>
                  600%
                </td>
                <td style={{ border: '1px solid black', padding: '8px', textAlign: 'center' }}>
                  1
                </td>
              </tr>
            </tbody>
          </table>
        </div>
      </ClassContent>
    ),
  },
  {
    name: 'Sorceress',
    image: sosoImg,
    content: (
      <ClassContent title="Sorceress">
        <div>
          <h3>Sorceress FHR</h3>
          <table style={{ borderCollapse: 'collapse', width: '100%' }}>
            <thead>
              <tr>
                <th style={{ border: '1px solid black', padding: '8px', textAlign: 'center' }}>
                  %
                </th>
                <th style={{ border: '1px solid black', padding: '8px', textAlign: 'center' }}>
                  Frames
                </th>
              </tr>
            </thead>
            <tbody>
              <tr>
                <td style={{ border: '1px solid black', padding: '8px', textAlign: 'center' }}>
                  0%
                </td>
                <td style={{ border: '1px solid black', padding: '8px', textAlign: 'center' }}>
                  15
                </td>
              </tr>
              <tr>
                <td style={{ border: '1px solid black', padding: '8px', textAlign: 'center' }}>
                  5%
                </td>
                <td style={{ border: '1px solid black', padding: '8px', textAlign: 'center' }}>
                  14
                </td>
              </tr>
              <tr>
                <td style={{ border: '1px solid black', padding: '8px', textAlign: 'center' }}>
                  9%
                </td>
                <td style={{ border: '1px solid black', padding: '8px', textAlign: 'center' }}>
                  13
                </td>
              </tr>
              <tr>
                <td style={{ border: '1px solid black', padding: '8px', textAlign: 'center' }}>
                  14%
                </td>
                <td style={{ border: '1px solid black', padding: '8px', textAlign: 'center' }}>
                  12
                </td>
              </tr>
              <tr>
                <td style={{ border: '1px solid black', padding: '8px', textAlign: 'center' }}>
                  20%
                </td>
                <td style={{ border: '1px solid black', padding: '8px', textAlign: 'center' }}>
                  11
                </td>
              </tr>
              <tr>
                <td style={{ border: '1px solid black', padding: '8px', textAlign: 'center' }}>
                  30%
                </td>
                <td style={{ border: '1px solid black', padding: '8px', textAlign: 'center' }}>
                  10
                </td>
              </tr>
              <tr>
                <td style={{ border: '1px solid black', padding: '8px', textAlign: 'center' }}>
                  42%
                </td>
                <td style={{ border: '1px solid black', padding: '8px', textAlign: 'center' }}>
                  9
                </td>
              </tr>
              <tr>
                <td style={{ border: '1px solid black', padding: '8px', textAlign: 'center' }}>
                  60%
                </td>
                <td style={{ border: '1px solid black', padding: '8px', textAlign: 'center' }}>
                  8
                </td>
              </tr>
              <tr>
                <td style={{ border: '1px solid black', padding: '8px', textAlign: 'center' }}>
                  86%
                </td>
                <td style={{ border: '1px solid black', padding: '8px', textAlign: 'center' }}>
                  7
                </td>
              </tr>
              <tr>
                <td style={{ border: '1px solid black', padding: '8px', textAlign: 'center' }}>
                  142%
                </td>
                <td style={{ border: '1px solid black', padding: '8px', textAlign: 'center' }}>
                  6
                </td>
              </tr>
              <tr>
                <td style={{ border: '1px solid black', padding: '8px', textAlign: 'center' }}>
                  280%
                </td>
                <td style={{ border: '1px solid black', padding: '8px', textAlign: 'center' }}>
                  5
                </td>
              </tr>
              <tr>
                <td style={{ border: '1px solid black', padding: '8px', textAlign: 'center' }}>
                  1480%
                </td>
                <td style={{ border: '1px solid black', padding: '8px', textAlign: 'center' }}>
                  4
                </td>
              </tr>
            </tbody>
          </table>

          <h3>Sorceress FCR</h3>
          <table style={{ borderCollapse: 'collapse', width: '100%' }}>
            <thead>
              <tr>
                <th style={{ border: '1px solid black', padding: '8px', textAlign: 'center' }}>
                  %
                </th>
                <th style={{ border: '1px solid black', padding: '8px', textAlign: 'center' }}>
                  Frames
                </th>
              </tr>
            </thead>
            <tbody>
              <tr>
                <td style={{ border: '1px solid black', padding: '8px', textAlign: 'center' }}>
                  0%
                </td>
                <td style={{ border: '1px solid black', padding: '8px', textAlign: 'center' }}>
                  13
                </td>
              </tr>
              <tr>
                <td style={{ border: '1px solid black', padding: '8px', textAlign: 'center' }}>
                  9%
                </td>
                <td style={{ border: '1px solid black', padding: '8px', textAlign: 'center' }}>
                  12
                </td>
              </tr>
              <tr>
                <td style={{ border: '1px solid black', padding: '8px', textAlign: 'center' }}>
                  20%
                </td>
                <td style={{ border: '1px solid black', padding: '8px', textAlign: 'center' }}>
                  11
                </td>
              </tr>
              <tr>
                <td style={{ border: '1px solid black', padding: '8px', textAlign: 'center' }}>
                  37%
                </td>
                <td style={{ border: '1px solid black', padding: '8px', textAlign: 'center' }}>
                  10
                </td>
              </tr>
              <tr>
                <td style={{ border: '1px solid black', padding: '8px', textAlign: 'center' }}>
                  63%
                </td>
                <td style={{ border: '1px solid black', padding: '8px', textAlign: 'center' }}>
                  9
                </td>
              </tr>
              <tr>
                <td style={{ border: '1px solid black', padding: '8px', textAlign: 'center' }}>
                  105%
                </td>
                <td style={{ border: '1px solid black', padding: '8px', textAlign: 'center' }}>
                  8
                </td>
              </tr>
              <tr>
                <td style={{ border: '1px solid black', padding: '8px', textAlign: 'center' }}>
                  200%
                </td>
                <td style={{ border: '1px solid black', padding: '8px', textAlign: 'center' }}>
                  7
                </td>
              </tr>
            </tbody>
          </table>

          <h3>Sorceress FBR</h3>
          <table style={{ borderCollapse: 'collapse', width: '100%' }}>
            <thead>
              <tr>
                <th style={{ border: '1px solid black', padding: '8px', textAlign: 'center' }}>
                  %
                </th>
                <th style={{ border: '1px solid black', padding: '8px', textAlign: 'center' }}>
                  Frames
                </th>
              </tr>
            </thead>
            <tbody>
              <tr>
                <td style={{ border: '1px solid black', padding: '8px', textAlign: 'center' }}>
                  0%
                </td>
                <td style={{ border: '1px solid black', padding: '8px', textAlign: 'center' }}>
                  9
                </td>
              </tr>
              <tr>
                <td style={{ border: '1px solid black', padding: '8px', textAlign: 'center' }}>
                  7%
                </td>
                <td style={{ border: '1px solid black', padding: '8px', textAlign: 'center' }}>
                  8
                </td>
              </tr>
              <tr>
                <td style={{ border: '1px solid black', padding: '8px', textAlign: 'center' }}>
                  15%
                </td>
                <td style={{ border: '1px solid black', padding: '8px', textAlign: 'center' }}>
                  7
                </td>
              </tr>
              <tr>
                <td style={{ border: '1px solid black', padding: '8px', textAlign: 'center' }}>
                  27%
                </td>
                <td style={{ border: '1px solid black', padding: '8px', textAlign: 'center' }}>
                  6
                </td>
              </tr>
              <tr>
                <td style={{ border: '1px solid black', padding: '8px', textAlign: 'center' }}>
                  48%
                </td>
                <td style={{ border: '1px solid black', padding: '8px', textAlign: 'center' }}>
                  5
                </td>
              </tr>
              <tr>
                <td style={{ border: '1px solid black', padding: '8px', textAlign: 'center' }}>
                  86%
                </td>
                <td style={{ border: '1px solid black', padding: '8px', textAlign: 'center' }}>
                  4
                </td>
              </tr>
              <tr>
                <td style={{ border: '1px solid black', padding: '8px', textAlign: 'center' }}>
                  200%
                </td>
                <td style={{ border: '1px solid black', padding: '8px', textAlign: 'center' }}>
                  3
                </td>
              </tr>
              <tr>
                <td style={{ border: '1px solid black', padding: '8px', textAlign: 'center' }}>
                  4680%
                </td>
                <td style={{ border: '1px solid black', padding: '8px', textAlign: 'center' }}>
                  2
                </td>
              </tr>
            </tbody>
          </table>
        </div>
      </ClassContent>
    ),
  },
  {
    name: 'Druid',
    image: duduImg,
    content: (
      <ClassContent title="Druid">
        <div>
          <h3>Druid FHR</h3>
          <p>Druid (*) hit by a 1-handed weapon or 2-handed sword held in one hand</p>
          <table style={{ borderCollapse: 'collapse', width: '100%' }}>
            <thead>
              <tr>
                <th style={{ border: '1px solid black', padding: '8px', textAlign: 'center' }}>
                  %
                </th>
                <th style={{ border: '1px solid black', padding: '8px', textAlign: 'center' }}>
                  Frames
                </th>
              </tr>
            </thead>
            <tbody>
              <tr>
                <td style={{ border: '1px solid black', padding: '8px', textAlign: 'center' }}>
                  0%
                </td>
                <td style={{ border: '1px solid black', padding: '8px', textAlign: 'center' }}>
                  14
                </td>
              </tr>
              <tr>
                <td style={{ border: '1px solid black', padding: '8px', textAlign: 'center' }}>
                  3%
                </td>
                <td style={{ border: '1px solid black', padding: '8px', textAlign: 'center' }}>
                  13
                </td>
              </tr>
              <tr>
                <td style={{ border: '1px solid black', padding: '8px', textAlign: 'center' }}>
                  7%
                </td>
                <td style={{ border: '1px solid black', padding: '8px', textAlign: 'center' }}>
                  12
                </td>
              </tr>
              <tr>
                <td style={{ border: '1px solid black', padding: '8px', textAlign: 'center' }}>
                  13%
                </td>
                <td style={{ border: '1px solid black', padding: '8px', textAlign: 'center' }}>
                  11
                </td>
              </tr>
              <tr>
                <td style={{ border: '1px solid black', padding: '8px', textAlign: 'center' }}>
                  19%
                </td>
                <td style={{ border: '1px solid black', padding: '8px', textAlign: 'center' }}>
                  10
                </td>
              </tr>
              <tr>
                <td style={{ border: '1px solid black', padding: '8px', textAlign: 'center' }}>
                  29%
                </td>
                <td style={{ border: '1px solid black', padding: '8px', textAlign: 'center' }}>
                  9
                </td>
              </tr>
              <tr>
                <td style={{ border: '1px solid black', padding: '8px', textAlign: 'center' }}>
                  42%
                </td>
                <td style={{ border: '1px solid black', padding: '8px', textAlign: 'center' }}>
                  8
                </td>
              </tr>
              <tr>
                <td style={{ border: '1px solid black', padding: '8px', textAlign: 'center' }}>
                  63%
                </td>
                <td style={{ border: '1px solid black', padding: '8px', textAlign: 'center' }}>
                  7
                </td>
              </tr>
              <tr>
                <td style={{ border: '1px solid black', padding: '8px', textAlign: 'center' }}>
                  99%
                </td>
                <td style={{ border: '1px solid black', padding: '8px', textAlign: 'center' }}>
                  6
                </td>
              </tr>
              <tr>
                <td style={{ border: '1px solid black', padding: '8px', textAlign: 'center' }}>
                  174%
                </td>
                <td style={{ border: '1px solid black', padding: '8px', textAlign: 'center' }}>
                  5
                </td>
              </tr>
              <tr>
                <td style={{ border: '1px solid black', padding: '8px', textAlign: 'center' }}>
                  456%
                </td>
                <td style={{ border: '1px solid black', padding: '8px', textAlign: 'center' }}>
                  4
                </td>
              </tr>
            </tbody>
          </table>

          <p>Druid hit by any other weapon</p>
          <table style={{ borderCollapse: 'collapse', width: '100%' }}>
            <thead>
              <tr>
                <th style={{ border: '1px solid black', padding: '8px', textAlign: 'center' }}>
                  %
                </th>
                <th style={{ border: '1px solid black', padding: '8px', textAlign: 'center' }}>
                  Frames
                </th>
              </tr>
            </thead>
            <tbody>
              <tr>
                <td style={{ border: '1px solid black', padding: '8px', textAlign: 'center' }}>
                  0%
                </td>
                <td style={{ border: '1px solid black', padding: '8px', textAlign: 'center' }}>
                  13
                </td>
              </tr>
              <tr>
                <td style={{ border: '1px solid black', padding: '8px', textAlign: 'center' }}>
                  5%
                </td>
                <td style={{ border: '1px solid black', padding: '8px', textAlign: 'center' }}>
                  12
                </td>
              </tr>
              <tr>
                <td style={{ border: '1px solid black', padding: '8px', textAlign: 'center' }}>
                  10%
                </td>
                <td style={{ border: '1px solid black', padding: '8px', textAlign: 'center' }}>
                  11
                </td>
              </tr>
              <tr>
                <td style={{ border: '1px solid black', padding: '8px', textAlign: 'center' }}>
                  16%
                </td>
                <td style={{ border: '1px solid black', padding: '8px', textAlign: 'center' }}>
                  10
                </td>
              </tr>
              <tr>
                <td style={{ border: '1px solid black', padding: '8px', textAlign: 'center' }}>
                  26%
                </td>
                <td style={{ border: '1px solid black', padding: '8px', textAlign: 'center' }}>
                  9
                </td>
              </tr>
              <tr>
                <td style={{ border: '1px solid black', padding: '8px', textAlign: 'center' }}>
                  39%
                </td>
                <td style={{ border: '1px solid black', padding: '8px', textAlign: 'center' }}>
                  8
                </td>
              </tr>
              <tr>
                <td style={{ border: '1px solid black', padding: '8px', textAlign: 'center' }}>
                  56%
                </td>
                <td style={{ border: '1px solid black', padding: '8px', textAlign: 'center' }}>
                  7
                </td>
              </tr>
              <tr>
                <td style={{ border: '1px solid black', padding: '8px', textAlign: 'center' }}>
                  86%
                </td>
                <td style={{ border: '1px solid black', padding: '8px', textAlign: 'center' }}>
                  6
                </td>
              </tr>
              <tr>
                <td style={{ border: '1px solid black', padding: '8px', textAlign: 'center' }}>
                  152%
                </td>
                <td style={{ border: '1px solid black', padding: '8px', textAlign: 'center' }}>
                  5
                </td>
              </tr>
              <tr>
                <td style={{ border: '1px solid black', padding: '8px', textAlign: 'center' }}>
                  377%
                </td>
                <td style={{ border: '1px solid black', padding: '8px', textAlign: 'center' }}>
                  4
                </td>
              </tr>
            </tbody>
          </table>

          <h3>Druid FCR</h3>
          <p>Druid (human)</p>
          <table style={{ borderCollapse: 'collapse', width: '100%' }}>
            <thead>
              <tr>
                <th style={{ border: '1px solid black', padding: '8px', textAlign: 'center' }}>
                  %
                </th>
                <th style={{ border: '1px solid black', padding: '8px', textAlign: 'center' }}>
                  Frames
                </th>
              </tr>
            </thead>
            <tbody>
              <tr>
                <td style={{ border: '1px solid black', padding: '8px', textAlign: 'center' }}>
                  0%
                </td>
                <td style={{ border: '1px solid black', padding: '8px', textAlign: 'center' }}>
                  18
                </td>
              </tr>
              <tr>
                <td style={{ border: '1px solid black', padding: '8px', textAlign: 'center' }}>
                  4%
                </td>
                <td style={{ border: '1px solid black', padding: '8px', textAlign: 'center' }}>
                  17
                </td>
              </tr>
              <tr>
                <td style={{ border: '1px solid black', padding: '8px', textAlign: 'center' }}>
                  10%
                </td>
                <td style={{ border: '1px solid black', padding: '8px', textAlign: 'center' }}>
                  16
                </td>
              </tr>
              <tr>
                <td style={{ border: '1px solid black', padding: '8px', textAlign: 'center' }}>
                  19%
                </td>
                <td style={{ border: '1px solid black', padding: '8px', textAlign: 'center' }}>
                  15
                </td>
              </tr>
              <tr>
                <td style={{ border: '1px solid black', padding: '8px', textAlign: 'center' }}>
                  30%
                </td>
                <td style={{ border: '1px solid black', padding: '8px', textAlign: 'center' }}>
                  14
                </td>
              </tr>
              <tr>
                <td style={{ border: '1px solid black', padding: '8px', textAlign: 'center' }}>
                  46%
                </td>
                <td style={{ border: '1px solid black', padding: '8px', textAlign: 'center' }}>
                  13
                </td>
              </tr>
              <tr>
                <td style={{ border: '1px solid black', padding: '8px', textAlign: 'center' }}>
                  68%
                </td>
                <td style={{ border: '1px solid black', padding: '8px', textAlign: 'center' }}>
                  12
                </td>
              </tr>
              <tr>
                <td style={{ border: '1px solid black', padding: '8px', textAlign: 'center' }}>
                  99%
                </td>
                <td style={{ border: '1px solid black', padding: '8px', textAlign: 'center' }}>
                  11
                </td>
              </tr>
              <tr>
                <td style={{ border: '1px solid black', padding: '8px', textAlign: 'center' }}>
                  163%
                </td>
                <td style={{ border: '1px solid black', padding: '8px', textAlign: 'center' }}>
                  10
                </td>
              </tr>
            </tbody>
          </table>

          <p>Druid (wolf)</p>
          <table style={{ borderCollapse: 'collapse', width: '100%' }}>
            <thead>
              <tr>
                <th style={{ border: '1px solid black', padding: '8px', textAlign: 'center' }}>
                  %
                </th>
                <th style={{ border: '1px solid black', padding: '8px', textAlign: 'center' }}>
                  Frames
                </th>
              </tr>
            </thead>
            <tbody>
              <tr>
                <td style={{ border: '1px solid black', padding: '8px', textAlign: 'center' }}>
                  0%
                </td>
                <td style={{ border: '1px solid black', padding: '8px', textAlign: 'center' }}>
                  16
                </td>
              </tr>
              <tr>
                <td style={{ border: '1px solid black', padding: '8px', textAlign: 'center' }}>
                  6%
                </td>
                <td style={{ border: '1px solid black', padding: '8px', textAlign: 'center' }}>
                  15
                </td>
              </tr>
              <tr>
                <td style={{ border: '1px solid black', padding: '8px', textAlign: 'center' }}>
                  14%
                </td>
                <td style={{ border: '1px solid black', padding: '8px', textAlign: 'center' }}>
                  14
                </td>
              </tr>
              <tr>
                <td style={{ border: '1px solid black', padding: '8px', textAlign: 'center' }}>
                  26%
                </td>
                <td style={{ border: '1px solid black', padding: '8px', textAlign: 'center' }}>
                  13
                </td>
              </tr>
              <tr>
                <td style={{ border: '1px solid black', padding: '8px', textAlign: 'center' }}>
                  40%
                </td>
                <td style={{ border: '1px solid black', padding: '8px', textAlign: 'center' }}>
                  12
                </td>
              </tr>
              <tr>
                <td style={{ border: '1px solid black', padding: '8px', textAlign: 'center' }}>
                  60%
                </td>
                <td style={{ border: '1px solid black', padding: '8px', textAlign: 'center' }}>
                  11
                </td>
              </tr>
              <tr>
                <td style={{ border: '1px solid black', padding: '8px', textAlign: 'center' }}>
                  95%
                </td>
                <td style={{ border: '1px solid black', padding: '8px', textAlign: 'center' }}>
                  10
                </td>
              </tr>
              <tr>
                <td style={{ border: '1px solid black', padding: '8px', textAlign: 'center' }}>
                  157%
                </td>
                <td style={{ border: '1px solid black', padding: '8px', textAlign: 'center' }}>
                  9
                </td>
              </tr>
            </tbody>
          </table>

          <p>Druid (bear)</p>
          <table style={{ borderCollapse: 'collapse', width: '100%' }}>
            <thead>
              <tr>
                <th style={{ border: '1px solid black', padding: '8px', textAlign: 'center' }}>
                  %
                </th>
                <th style={{ border: '1px solid black', padding: '8px', textAlign: 'center' }}>
                  Frames
                </th>
              </tr>
            </thead>
            <tbody>
              <tr>
                <td style={{ border: '1px solid black', padding: '8px', textAlign: 'center' }}>
                  0%
                </td>
                <td style={{ border: '1px solid black', padding: '8px', textAlign: 'center' }}>
                  16
                </td>
              </tr>
              <tr>
                <td style={{ border: '1px solid black', padding: '8px', textAlign: 'center' }}>
                  7%
                </td>
                <td style={{ border: '1px solid black', padding: '8px', textAlign: 'center' }}>
                  15
                </td>
              </tr>
              <tr>
                <td style={{ border: '1px solid black', padding: '8px', textAlign: 'center' }}>
                  15%
                </td>
                <td style={{ border: '1px solid black', padding: '8px', textAlign: 'center' }}>
                  14
                </td>
              </tr>
              <tr>
                <td style={{ border: '1px solid black', padding: '8px', textAlign: 'center' }}>
                  26%
                </td>
                <td style={{ border: '1px solid black', padding: '8px', textAlign: 'center' }}>
                  13
                </td>
              </tr>
              <tr>
                <td style={{ border: '1px solid black', padding: '8px', textAlign: 'center' }}>
                  40%
                </td>
                <td style={{ border: '1px solid black', padding: '8px', textAlign: 'center' }}>
                  12
                </td>
              </tr>
              <tr>
                <td style={{ border: '1px solid black', padding: '8px', textAlign: 'center' }}>
                  63%
                </td>
                <td style={{ border: '1px solid black', padding: '8px', textAlign: 'center' }}>
                  11
                </td>
              </tr>
              <tr>
                <td style={{ border: '1px solid black', padding: '8px', textAlign: 'center' }}>
                  99%
                </td>
                <td style={{ border: '1px solid black', padding: '8px', textAlign: 'center' }}>
                  10
                </td>
              </tr>
              <tr>
                <td style={{ border: '1px solid black', padding: '8px', textAlign: 'center' }}>
                  163%
                </td>
                <td style={{ border: '1px solid black', padding: '8px', textAlign: 'center' }}>
                  9
                </td>
              </tr>
            </tbody>
          </table>

          <h3>Druid FBR</h3>
          <p>Druid</p>
          <table style={{ borderCollapse: 'collapse', width: '100%' }}>
            <thead>
              <tr>
                <th style={{ border: '1px solid black', padding: '8px', textAlign: 'center' }}>
                  %
                </th>
                <th style={{ border: '1px solid black', padding: '8px', textAlign: 'center' }}>
                  Frames
                </th>
              </tr>
            </thead>
            <tbody>
              <tr>
                <td style={{ border: '1px solid black', padding: '8px', textAlign: 'center' }}>
                  0%
                </td>
                <td style={{ border: '1px solid black', padding: '8px', textAlign: 'center' }}>
                  11
                </td>
              </tr>
              <tr>
                <td style={{ border: '1px solid black', padding: '8px', textAlign: 'center' }}>
                  6%
                </td>
                <td style={{ border: '1px solid black', padding: '8px', textAlign: 'center' }}>
                  10
                </td>
              </tr>
              <tr>
                <td style={{ border: '1px solid black', padding: '8px', textAlign: 'center' }}>
                  13%
                </td>
                <td style={{ border: '1px solid black', padding: '8px', textAlign: 'center' }}>
                  9
                </td>
              </tr>
              <tr>
                <td style={{ border: '1px solid black', padding: '8px', textAlign: 'center' }}>
                  20%
                </td>
                <td style={{ border: '1px solid black', padding: '8px', textAlign: 'center' }}>
                  8
                </td>
              </tr>
              <tr>
                <td style={{ border: '1px solid black', padding: '8px', textAlign: 'center' }}>
                  32%
                </td>
                <td style={{ border: '1px solid black', padding: '8px', textAlign: 'center' }}>
                  7
                </td>
              </tr>
              <tr>
                <td style={{ border: '1px solid black', padding: '8px', textAlign: 'center' }}>
                  52%
                </td>
                <td style={{ border: '1px solid black', padding: '8px', textAlign: 'center' }}>
                  6
                </td>
              </tr>
              <tr>
                <td style={{ border: '1px solid black', padding: '8px', textAlign: 'center' }}>
                  86%
                </td>
                <td style={{ border: '1px solid black', padding: '8px', textAlign: 'center' }}>
                  5
                </td>
              </tr>
              <tr>
                <td style={{ border: '1px solid black', padding: '8px', textAlign: 'center' }}>
                  174%
                </td>
                <td style={{ border: '1px solid black', padding: '8px', textAlign: 'center' }}>
                  4
                </td>
              </tr>
              <tr>
                <td style={{ border: '1px solid black', padding: '8px', textAlign: 'center' }}>
                  600%
                </td>
                <td style={{ border: '1px solid black', padding: '8px', textAlign: 'center' }}>
                  3
                </td>
              </tr>
            </tbody>
          </table>

          <p>Druid (Wolf)</p>
          <table style={{ borderCollapse: 'collapse', width: '100%' }}>
            <thead>
              <tr>
                <th style={{ border: '1px solid black', padding: '8px', textAlign: 'center' }}>
                  %
                </th>
                <th style={{ border: '1px solid black', padding: '8px', textAlign: 'center' }}>
                  Frames
                </th>
              </tr>
            </thead>
            <tbody>
              <tr>
                <td style={{ border: '1px solid black', padding: '8px', textAlign: 'center' }}>
                  0%
                </td>
                <td style={{ border: '1px solid black', padding: '8px', textAlign: 'center' }}>
                  9
                </td>
              </tr>
              <tr>
                <td style={{ border: '1px solid black', padding: '8px', textAlign: 'center' }}>
                  7%
                </td>
                <td style={{ border: '1px solid black', padding: '8px', textAlign: 'center' }}>
                  8
                </td>
              </tr>
              <tr>
                <td style={{ border: '1px solid black', padding: '8px', textAlign: 'center' }}>
                  15%
                </td>
                <td style={{ border: '1px solid black', padding: '8px', textAlign: 'center' }}>
                  7
                </td>
              </tr>
              <tr>
                <td style={{ border: '1px solid black', padding: '8px', textAlign: 'center' }}>
                  27%
                </td>
                <td style={{ border: '1px solid black', padding: '8px', textAlign: 'center' }}>
                  6
                </td>
              </tr>
              <tr>
                <td style={{ border: '1px solid black', padding: '8px', textAlign: 'center' }}>
                  48%
                </td>
                <td style={{ border: '1px solid black', padding: '8px', textAlign: 'center' }}>
                  5
                </td>
              </tr>
              <tr>
                <td style={{ border: '1px solid black', padding: '8px', textAlign: 'center' }}>
                  86%
                </td>
                <td style={{ border: '1px solid black', padding: '8px', textAlign: 'center' }}>
                  4
                </td>
              </tr>
              <tr>
                <td style={{ border: '1px solid black', padding: '8px', textAlign: 'center' }}>
                  200%
                </td>
                <td style={{ border: '1px solid black', padding: '8px', textAlign: 'center' }}>
                  3
                </td>
              </tr>
            </tbody>
          </table>

          <p>Druid (Bear)</p>
          <table style={{ borderCollapse: 'collapse', width: '100%' }}>
            <thead>
              <tr>
                <th style={{ border: '1px solid black', padding: '8px', textAlign: 'center' }}>
                  %
                </th>
                <th style={{ border: '1px solid black', padding: '8px', textAlign: 'center' }}>
                  Frames
                </th>
              </tr>
            </thead>
            <tbody>
              <tr>
                <td style={{ border: '1px solid black', padding: '8px', textAlign: 'center' }}>
                  0%
                </td>
                <td style={{ border: '1px solid black', padding: '8px', textAlign: 'center' }}>
                  12
                </td>
              </tr>
              <tr>
                <td style={{ border: '1px solid black', padding: '8px', textAlign: 'center' }}>
                  5%
                </td>
                <td style={{ border: '1px solid black', padding: '8px', textAlign: 'center' }}>
                  11
                </td>
              </tr>
              <tr>
                <td style={{ border: '1px solid black', padding: '8px', textAlign: 'center' }}>
                  10%
                </td>
                <td style={{ border: '1px solid black', padding: '8px', textAlign: 'center' }}>
                  10
                </td>
              </tr>
              <tr>
                <td style={{ border: '1px solid black', padding: '8px', textAlign: 'center' }}>
                  16%
                </td>
                <td style={{ border: '1px solid black', padding: '8px', textAlign: 'center' }}>
                  9
                </td>
              </tr>
              <tr>
                <td style={{ border: '1px solid black', padding: '8px', textAlign: 'center' }}>
                  27%
                </td>
                <td style={{ border: '1px solid black', padding: '8px', textAlign: 'center' }}>
                  8
                </td>
              </tr>
              <tr>
                <td style={{ border: '1px solid black', padding: '8px', textAlign: 'center' }}>
                  40%
                </td>
                <td style={{ border: '1px solid black', padding: '8px', textAlign: 'center' }}>
                  7
                </td>
              </tr>
              <tr>
                <td style={{ border: '1px solid black', padding: '8px', textAlign: 'center' }}>
                  65%
                </td>
                <td style={{ border: '1px solid black', padding: '8px', textAlign: 'center' }}>
                  6
                </td>
              </tr>
              <tr>
                <td style={{ border: '1px solid black', padding: '8px', textAlign: 'center' }}>
                  109%
                </td>
                <td style={{ border: '1px solid black', padding: '8px', textAlign: 'center' }}>
                  5
                </td>
              </tr>
              <tr>
                <td style={{ border: '1px solid black', padding: '8px', textAlign: 'center' }}>
                  223%
                </td>
                <td style={{ border: '1px solid black', padding: '8px', textAlign: 'center' }}>
                  4
                </td>
              </tr>
            </tbody>
          </table>
        </div>
      </ClassContent>
    ),
  },
];

const Breakpoints: React.FC<object> = () => {
  return (
    <span>
      <div className="container">
        <NavPills
          queryKey={'class'}
          alignCenter
          color="primary"
          onChange={() => {}}
          tabs={[
            {
              tabName: 'all',
              tabButton: (
                <span style={{ display: 'block' }}>
                  <img style={{ width: '64px' }} src={d2rsIcon} alt="d2rs" />
                </span>
              ),
              tabContent: (
                <ClassContent title="All Classes">
                  <img
                    src={breakpointsImg}
                    alt="Second slide"
                    style={{
                      marginTop: '10px',
                    }}
                  />
                </ClassContent>
              ),
            },
            ...bpClasses.map((obj, index) => ({
              tabName: obj.name,
              tabButton: (
                <span style={{ display: 'block' }} key={index}>
                  <img style={{ width: '64px' }} src={obj.image} alt={obj.name} />
                </span>
              ),
              tabContent: obj.content,
            })),
          ]}
        />
      </div>
    </span>
  );
};

export default Breakpoints;
